import { ItemList } from '../orm'

class SquarePayment extends ItemList {
  getEntityKey() {
    return "customer/purchased_trolley/create_square_payment"
  }

  async getSquareCard(onPaymentFailure) {
    if (!window.Square) {
      onPaymentFailure('Unable to connect to Square SDK')
      return null
    }

    let payments
    try {
      payments = window.Square.payments(
        window.LOCAL_SETTINGS.SQUARE_APP_ID,
        window.LOCAL_SETTINGS.SQUARE_LOCATION_ID,
      )
    } catch (error) {
      onPaymentFailure('Missing credentials')
      return null
    }

    try {
      const card = await payments.card()
      await card.attach('#card-container')
      return card
    } catch (error) {
      onPaymentFailure('Unable to initialise Square')
      return null
    }
  }

  async getSquareToken(card, totalPriceOwingByCustomer) {
    const verificationDetails = {
      amount: `${totalPriceOwingByCustomer.toFixed(2)}`,
      billingContact: {},
      currencyCode: 'AUD',
      intent: 'CHARGE',
      customerInitiated: true,
      sellerKeyedIn: false,
    }

    try {
      const result = await card.tokenize(verificationDetails)
      if (result.status === 'OK') {
        return result.token
      }
      throw new Error('Could not tokenize')
    } catch (error) {
      return null
    }
  }

  createPayment({ token, trolley, totalPriceOwingByCustomer }) {
    return this.saveNewObject({
      token: token,
      trolley_ref: trolley?.id,
      total_price_owing_by_customer: totalPriceOwingByCustomer,
    })
  }
}

export const squarePayment = new SquarePayment("square_payment_default")


